"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
let VdBindAdmin = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(new APIDataSource("api://base.auth/api/v7/users"));
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "first";
    this.searchStr = "";
    this.open_type = "";
    this.rows = [];
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.filter = `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.filter = `userStatus=='0'`;
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
    this.gridController.query.filter = `userStatus=='0'`;
  }
  mounted() {
  }
  open(openType, rows, selectDatas = []) {
    this.open_type = openType;
    this.rows = rows;
    this.searchStr = "";
    this.selectDatas = [];
    this.selectLock = false;
    this.gridController.query.sort = "asc";
    this.gridController.query.filter = `userStatus=='0'`;
    this.gridController.search();
    this._distributionDialog.open();
    this.$nextTick(() => {
      for (const item of selectDatas) {
        this._distributionDialog.add(item);
      }
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      let userIds = [];
      for (const item of data) {
        userIds.push(item.id);
      }
      let vdIds = [];
      for (const item of this.rows) {
        vdIds.push(item.oldId);
      }
      try {
        if (this.open_type === "single") {
          yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
            "vdIds": vdIds,
            "userIds": userIds,
            "isCoverage": true,
            "type": "VD"
          });
          this.$message.success(this.$t("vdbindadmin.binding_successful"));
          this._distributionDialog.close();
          this.$emit("refresh");
        }
        if (this.open_type === "multi") {
          yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
            "vdIds": vdIds,
            "userIds": userIds,
            "isCoverage": false,
            "type": "VD"
          });
          this.$message.success(this.$t("vdbindadmin.binding_successful"));
          this._distributionDialog.close();
          this.$emit("refresh");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(this.gridController.result.datas, items, _.isEqual);
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.guid == data2.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.guid == data.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
};
__decorateClass([
  Ref("distributionDialog")
], VdBindAdmin.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], VdBindAdmin.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(400)
], VdBindAdmin.prototype, "saved", 1);
VdBindAdmin = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], VdBindAdmin);
export {
  VdBindAdmin as default
};
